<template>
  <div class="dashboard">


    <div class="row">
        <div class="flex xs12 sm12 lg12">
          <va-card >
           <p  style="font-size: 25px"> {{$t('dashboard.SistemaGestao')}}</p>
                    <hr>
          </va-card>
        </div>
    </div>

     <div class="row">
      
        <div class="flex xs12 sm12 lg3">
          <va-card title="Cursos">
                <va-button  :color="cursos.color" :style="cursos" > Doutorado</va-button>
                <hr>
                <va-button  :color="materias.color" :style="materias" > Materia</va-button>
                <va-button  :color="materias.color" :style="materias" > Materia</va-button>
                <va-button  :color="materias.color" :style="materias" > Materia</va-button>
                <va-button  :color="materias.color" :style="materias" > Materia</va-button>
         </va-card>
        </div>

        <div class="flex xs12 sm12 lg9">
          <va-card >
              <div class="row">
            
              <div class="flex xs12 sm12 lg3">   
                <va-button v-on:click="currentTab = videos.componet" :color="videos.color" :style="videos" > {{ $t('Geral.Videos') }}</va-button>
              </div>
              <div class="flex xs12 sm12 lg3">   
                <va-button v-on:click="currentTab = GradeCurricular.componet" :color="GradeCurricular.color" :style="GradeCurricular" > {{ $t('Geral.Slides') }}</va-button>
              </div>
              <div class="flex xs12 sm12 lg3">   
                <va-button v-on:click="currentTab = TipoDisciplina.componet" :color="TipoDisciplina.color" :style="TipoDisciplina" > {{ $t('Geral.Audios') }}</va-button>
             </div>
              <div class="flex xs12 sm12 lg3">   
                <va-button v-on:click="currentTab = TipoCurso.componet" :color="TipoCurso.color" :style="TipoCurso" > {{ $t('Geral.Questionario') }}</va-button>
              </div>
        
     
  </div>
         
          <component v-bind:is="currentTabComponent"></component>
          </va-card>
        </div>
    </div>

  </div>
</template>

<script>
import videos from './Videos'
import disciplinas from './Disciplinas'
import gradecurricular from './Gradecurricular'
import tipodisciplina from './Tipodisciplina'
import tipocurso from './Tipocurso'

export default {
  name: 'dashboard',
  components: {
   videos,
   disciplinas,
   gradecurricular,
   tipodisciplina,
   tipocurso

  },

  data () {
      return {
        cursos: {
          color:'dark',
          'width': '100%',
        }, 
        materias: {
          color:'success',
          'width': '100%',
        }, 
        videos: {
          componet: 'videos',
          color:'dark',
          'width': '100%',
        }, 
        Disciplinas: {
           componet: 'Disciplinas',
          color:'dark',
          'width': '100%',
        }, 
        GradeCurricular: {
          componet: 'GradeCurricular',
          color:'dark',
          'width': '100%',
        }, 
        TipoDisciplina: {
          componet: 'TipoDisciplina',
          color:'dark',
          'width': '100%',
        }, 
        TipoCurso: {
          componet: 'TipoCurso',
          color:'dark',
          'min-width': '100%',
        }, 

      currentTab: 'cursos',
     
      }
    },

  computed: {
    currentTabComponent () {
      console.log(this.currentTab)
      return  this.currentTab.toLowerCase()

    }
  },

  methods: {
    
 
  },
}
</script>

<style lang="scss">
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }
  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
</style>
